import { render, staticRenderFns } from "./ClientContact.vue?vue&type=template&id=4d9510e8&scoped=true&"
import script from "./ClientContact.vue?vue&type=script&lang=js&"
export * from "./ClientContact.vue?vue&type=script&lang=js&"
import style0 from "./ClientContact.vue?vue&type=style&index=0&id=4d9510e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9510e8",
  null
  
)

export default component.exports